import React from 'react';
import { Box, CardMedia } from '@mui/material';

import noImage from '../../assets/no-image.png';
import { v2Colors } from '../../design/theme';

const THUMB_MAX = 4;

export default function ProductDetailHero({
  images,
  productName,
  selectedImage,
  onSelectImage,
  stockLabel,
  inStock,
}) {
  const list = images?.length ? images : [noImage];
  const thumbs = list.slice(0, THUMB_MAX);

  return (
    <Box sx={{ mb: 2.5, md: { mb: 0, maxWidth: 300 } }}>
    <Box
      sx={{
        position: 'relative',
        minHeight: 280,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        md: {
          minHeight: 200,
          maxHeight: 240,
          borderRadius: 3,
          bgcolor: v2Colors.surface,
          border: `1px solid ${v2Colors.borderMuted}`,
          overflow: 'hidden',
          py: 2,
          px: 2,
        },
      }}
    >
      <CardMedia
        component="img"
        image={list[selectedImage] || noImage}
        alt={productName || 'Product'}
        sx={{
          width: '100%',
          maxHeight: 320,
          objectFit: 'contain',
          py: 3,
          px: 2,
          borderRadius: '50px',
          display: 'block',
          md: {
            maxWidth: 200,
            maxHeight: 160,
            py: 0,
            px: 0,
            borderRadius: 0,
          },
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,
          px: 1.25,
          py: 0.5,
          borderRadius: 10,
          bgcolor: inStock ? v2Colors.selectedFill : v2Colors.surface,
          border: `1px solid ${inStock ? v2Colors.primary : v2Colors.borderMuted}`,
          md: {
            bgcolor: v2Colors.white,
          },
        }}
      >
        <Box
          component="span"
          sx={{
            fontSize: '0.72rem',
            fontWeight: 600,
            color: inStock ? v2Colors.primary : v2Colors.textMuted,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Box
            component="span"
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: inStock ? v2Colors.primary : v2Colors.slotDisabled,
            }}
          />
          {stockLabel}
        </Box>
      </Box>

      {list.length > 1 ? (
        <Box
          sx={{
            position: 'absolute',
            bottom: 14,
            left: 0,
            right: 0,
            display: { xs: 'flex', md: 'none' },
            justifyContent: 'center',
            gap: 0.75,
          }}
        >
          {list.map((_, idx) => (
            <Box
              key={idx}
              component="button"
              type="button"
              aria-label={`Image ${idx + 1}`}
              onClick={() => onSelectImage(idx)}
              sx={{
                border: 'none',
                p: 0,
                width: selectedImage === idx ? 22 : 8,
                height: 8,
                borderRadius: 4,
                bgcolor: selectedImage === idx ? v2Colors.primary : v2Colors.borderMuted,
                cursor: 'pointer',
                transition: 'width 0.15s ease',
              }}
            />
          ))}
        </Box>
      ) : null}

    </Box>

      {thumbs.length > 1 ? (
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            mt: 1.25,
            justifyContent: 'center',
            gap: 0.75,
          }}
        >
          {thumbs.map((src, idx) => {
            const selected = selectedImage === idx;
            return (
              <Box
                key={idx}
                component="button"
                type="button"
                aria-label={`Image ${idx + 1}`}
                aria-pressed={selected}
                onClick={() => onSelectImage(idx)}
                sx={{
                  border: '2px solid',
                  borderColor: selected ? v2Colors.primary : v2Colors.white,
                  borderRadius: 1.5,
                  p: 0,
                  width: 44,
                  height: 44,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  bgcolor: v2Colors.white,
                  boxShadow: selected
                    ? `0 0 0 1px ${v2Colors.primary}`
                    : '0 1px 4px rgba(26, 19, 15, 0.08)',
                }}
              >
                <Box
                  component="img"
                  src={src}
                  alt=""
                  sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImage;
                  }}
                />
              </Box>
            );
          })}
        </Box>
      ) : null}
    </Box>
  );
}
